<fc-top-header-switcher *ngIf="isAuthenticated"></fc-top-header-switcher>
<router-outlet></router-outlet>
<fc-footer-switcher *ngIf="isAuthenticated"></fc-footer-switcher>